<template>
  <div class="blockly-wrap">
    <div class="blockly-tool">
      <el-button id="btnUndo" class="btn-undo" @click="undoHandle"
        >撤销
      </el-button>
      <el-button id="btnRedo" class="btn-redo" @click="redoHandle"
        >重做
      </el-button>
      <el-button id="btnResetSvg" class="btn-reset-svg">整理</el-button>
      <el-button id="btnRun" class="btn-run" @click="runHandle">运行</el-button>
    </div>
    <!--  回收站-->
    <div class="recycle-wrap" v-if="dragBlockStatu">
      <i class="recycle-bin"></i>
    </div>
    <div
      :class="['code-editer', { 'space-hide': workspaceIsVisible }]"
      contenteditable="false"
    >
      <el-button id="btnCodeEditer" class="btn-mode-code" @click="modeToCode"
        >代码模式</el-button
      >
      <!--  <pre id="codeEditerBox" contenteditable="true"></pre>-->
      <python-editor v-model="pythonEditorCode"></python-editor>
    </div>
    <div
      id="blocklyBox"
      :class="['blockly-box', { 'space-hide': !workspaceIsVisible }]"
    ></div>

    <xml id="toolBox" style="display:none">
      <slot></slot>
    </xml>
    <xml id="toolBox2" style="display:none">
      <slot></slot>
    </xml>

    <!-- 弹框 -->
    <div class="popup-list list-2"></div>
  </div>
</template>

<script>
// import Blockly from "blockly";
// 注册 gta 渲染器
// 备注：
// 摄像头和照片积木采用相同的接口进行上传和获取，分开picTemlist 和camTemlist进行缓存;

import Blockly from '@/assets/blockly/renderers/index.js'
import GTheme from '@/assets/blockly/theme/gtheme.js'
import BlocklLangMsg from 'BlocklLangMsg'
// import GatPopup from '@/components/common/GatPopup'
import PythonEditor from '@/components/common/PythonEditor'
// import blockSvg from '@/components/blocklyEditor/common/BlockSvg.vue'
// import DefBlock from '@/components/blocklyEditor/common/DefBlock.vue'
import { mapGetters } from 'vuex'
// import clickOutside from '@/plugins/directives/click-outside'
import bus from '@/utils/bus'

import { gtaMsgHans } from '../../../public/blockly/msg/details/zh-hans-gta.js'
//实训接口
// import BLOCK from '@/axios/trainingCenter/AiEditor/blocks.js'
//项目接口
// import AI_EDITOR from '@/axios/personalSpace/AiEditor/blocks.js'
//上传文件等公共接口
// import COMMON from '@/axios/common/common.js'

/*混入了媒体积木的  createBlocksByList() 功能模块;*/
// import { MediaBlocks } from '@/assets/js/mixin/mixinMediaBlocks.js'
/*混入了功能模块;*/
// import { CreateBlock } from '@/assets/js/mixin/mixinCreateBlock.js'

export default {
  name: 'BlocklyEditor',
  components: {
    // GatPopup,
    // blockSvg,
    PythonEditor,
    // DefBlock,
  },
  // directives: { clickOutside },
  model: {
    prop: 'blocks',
    event: 'cc',
  },
  // mixins: [CreateBlock],
  props: {
    // 工作台积木脚本
    blockXmlText: {
      type: String,
      default: null,
    },
    // Media: {
    //   //媒体积木列表
    //   type: Array,
    //   default() {
    //     return []
    //   },
    // },
    // 项目ID
    projectId: {
      type: String,
      default: null,
    },
    trainingId: {
      type: String,
      default: null,
    },
    // xml 保存相关数据
    xmlData: {
      type: Object,
      default: () => {
        return {
          str: '',
          name: '',
          type: 1,
          path: '',
        }
      },
    },
    // 保存指令 flag，保存指令传达，prevSaveWorkSpaceXmlTxt 将会保存一次，用来比较是否有所改变
    saveFlag: {
      type: Number,
      default: 0,
    },
    // 语言信息
    langMsg: {
      type: Object,
      default: () => {
        return BlocklLangMsg.en
      },
    },
    // 颜色主题
    theme: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 渲染器
    renderer: {
      type: String,
      default: 'gta',
    },
    // 自定义模块添加
    blocks: {
      type: Object,
      default: () => {
        return {}
      },
    },
    workspaceIsVisible: {
      type: Boolean,
      default: true,
    },
    stepOperate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconEdite2: require('../../assets/images/icon-edite2.png'),
      iconView: require('../../assets/images/icon-view.png'),
      iconNoMessage: require('../../assets/images/icon-nomessage.png'),
      pythonEditorCode: '',
      netCamera: {
        name: '',
        url: window.gtaAiConfig.netCameraObj.url,
        path: '',
        host1: window.gtaAiConfig.netCameraObj.host,
        // host1: "http://10.1.137.215:5000/video_feed?videopath=",
        isPreview: false,
      },
      localCamera: {
        url: '',
      },
      renameVal: '', //重命名值
      blockType: '', //积木类型
      popupActive: '',
      workspace: null,
      MSG: {},
      rendererName: 'gta',
      oldWorkspaceXmlTxt: '',
      prevSaveWorkSpaceXmlTxt: '',
      // picTempList: [], //图片积木缓存-写在mixin
      // camTempList: [], //摄像头积木缓存-写在mixin
      // audioTempList: [], //摄像头积木缓存-写在mixin
      // renamePicObj: {}, //缓存重命名的图片积木-写在mixin
      // renameCamObj: {}, //缓存重命名的摄像头积木-写在mixin
      // renameAudioObj: {}, //缓存重命名的音频积木-写在mixin
      // Media: [],
      mediaGotten: 0,
      Placeholder: {
        ProjectId: '00000000-0000-0000-0000-000000000000',
      },
      elMedia: null,
      blockIcon: require('../../../public/images/block.png'),
      newBLockInfo: {
        blockName: '',
        paramsList: [],
      },
      createBlockMenu: [
        {
          label: '文本',
          value: 'text',
        },
        {
          label: '数字',
          value: 'number',
        },
      ],
      createBlockParam: 'text',
      newBlockScript: null,
      paramValText: '', //python脚本中获取变量的脚本
    }
  }, //data end
  inject: {
    reload: {
      default: () => {
        return 'reload'
      },
    },
    blockSData: {
      default: () => {
        return { Items: [], TotalCount: 0 }
      },
    },
  },
  // inject: ["reload", "blockSData"],
  watch: {
    blocksList: {
      handler(blocksList, oldBlocksList) {
        this.addBlockCollectionToToolbox(Blockly, null, blocksList)
      },
      // immediate: true,
      deep: true,
    },
    blockXmlText(xmlText) {
      if (xmlText) {
        // this.createBlocksByWorkspaceXML(xmlText, true)

        this.textToWorkspace(xmlText)
      }
    },
    workspaceIsVisible(val) {
      this.workspace.setVisible(val)
    },
    stepOperate(val) {
      if (val === 'undo') {
        this.undoHandle()
      } else if (val === 'redo') {
        this.redoHandle()
      }
    },
    blocks: {
      handler(blocks, oldBlocks) {},
      deep: true,
    },
    saveFlag() {
      // 保存一下旧代码
      if (this.workspace) {
        this.prevSaveWorkSpaceXmlTxt = this.workspaceToDom().outerHTML
      }
    },
  },
  //计算属性
  computed: {
    blocksList() {
      return this.blockSData.Items
    },
    myScore() {
      return this.getScore
    },
    ...mapGetters(['accountInfo', 'createBy', 'dragBlockStatu']),
  },
  created() {
    let self = this
    // this.newBlocks = this.$store.state.CREATEBLOCK.newBlocks
    // 工作台生成积木
    bus.$on('textToWorkspace', (xmlText) => {
      self.textToWorkspace(xmlText)
    })
    // window.addEventListener('mousedown',e=>{
    //   // console.log("mousedown",e);
    // })
    //初始化
    // this.picTempList = []
  },
  mounted() {
    // let toolBoxDom;

    // 界面语言设置
    this.MSG = BlocklLangMsg.zhHans
    require('../../../public/blockly/msg/details/zh-hans')
    gtaMsgHans()
    // 主题设置
    Blockly.Theme.GTheme = new Blockly.Theme(
      GTheme.defaultBlockStyles,
      GTheme.categoryStyles
    )
    //积木渐变
    setTimeout(() => {
      this.blocksGradient()
    }, 1000)

    /**代码回收
     * Distance between trashcan and right edge of workspace.
     * @type {number}
     * @private
     */
    Blockly.SPRITE.width = 296 * 1.5 // sprite 更改 296
    require('@/assets/blockly/transhcan/trashcan.js')
    Blockly.Trashcan.prototype.MARGIN_SIDE_ = 10 //0

    // 载入编程语言y
    require('../../../public/blockly/code/python_compressed.js')
    //语言文本
    require('../../../public/blockly/msg/details/zh-hans.js')
    console.log(Blockly.Msg['COLOUR_BLEND_HELPURL'])
    // require("../../../public/blockly/code/python_compressed.js");

    // 载入事件积木模块
    require('@/assets/blockly/blocks/gta_ai_event.js')
    require('@/assets/blockly/blocks/gta_ai_math.js')
    require('@/assets/blockly/blocks/gta_ai_text.js')
    require('@/assets/blockly/blocks/gta_ai_list.js')
    require('@/assets/blockly/blocks/gta_ai_control.js')
    require('@/assets/blockly/blocks/gta_ai_dict.js')
    require('@/assets/blockly/blocks/gta_ai_procedures.js')
    require('@/assets/blockly/blocks/gta_ai_variables.js')
    require('@/assets/blockly/blocks/gta_ai_media.js')
    require('@/assets/blockly/blocks/gta_ai_item.js')
    // require('@/assets/blockly/blocks/gta_ai_robot.js')
    require('@/assets/blockly/blocks/gta_ai_turtle.js')

    // Blockly 初始化
    this.blocklyInit()

    if (window) {
      window.addEventListener('resize', this.onresize, false)
    }

    // 在基本积木基础上添加新的积木
    let blockItems = this.blocksList || []
    this.addBlockCollectionToToolbox(Blockly, null, blockItems)

    // 添加图片分类
    // <category name="图片" custom="upload_pic"></category>
    // this.workspace.dispose();
    // toolBoxDom = document.getElementById('toolBox')

    //注册分类
    // this.workspace.registerToolboxCategoryCallback(
    //   'upload_pic',
    //   this.coloursFlyoutCallback
    // )

    //注册创建图片按钮
    // this.workspace.registerButtonCallback(
    //   'myFirstButtonPressed',
    //   this.btnCreatePictureBlock
    // )
    // //注册创建摄像头按钮
    // this.workspace.registerButtonCallback(
    //   'myFirstButtonPressed2',
    //   this.btnCreateCameraBlock
    // )
    // //注册创建音频按钮
    // this.workspace.registerButtonCallback(
    //   'myFirstButtonPressed3',
    //   this.btnCreateAudioBlock
    // )
    // //注册创建文本按钮
    // this.workspace.registerButtonCallback(
    //   'myFirstButtonPressed4',
    //   this.btnCreateTextBlock
    // )

    //监听mousedown事件
    let blocklyHtmlInput = document.getElementsByClassName('blocklyHtmlInput')
    document.addEventListener('mousedown', (e) => {
      if (blocklyHtmlInput && blocklyHtmlInput.length) {
        if (e.target.className != 'blocklyHtmlInput') {
          let doms = document.getElementsByClassName('blocklyWidgetDiv')
          doms = Array.from(doms)
          if (!doms) return
          doms.forEach((item) => {
            item.style.display = 'none'
          })
        }
      }
    })
  },
  beforeDestroy() {
    
    bus.$off('textToWorkspace')
    let doms = document.getElementsByClassName('blocklyWidgetDiv')
    doms = Array.from(doms)
    if (!doms) return
    doms.forEach((item) => {
      item.style.display = 'none'
    })

    try {
      document.removeEventListener('mousedown')
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    blocklyInit(oldWorkspaceXml) {
      //初始化积木
      var toolboxXml = this.setToolboxText(),
        resetSvgDom = document.getElementById('btnResetSvg'),
        oldWorkspaceXmlTxt = '',
        oldWorkspaceXmlTmp

      if (oldWorkspaceXml) {
        oldWorkspaceXmlTxt =
          typeof oldWorkspaceXml === 'string'
            ? oldWorkspaceXml
            : oldWorkspaceXml.outerHTML
        // this.createBlocksByWorkspaceXML(oldWorkspaceXmlTxt)
      }

      this.workspace = Blockly.inject(document.getElementById('blocklyBox'), {
        toolbox: toolboxXml,
        grid: {
          spacing: 25,
          length: 3,
          colour: 'rgba(255,255,255,0)',
          snap: true,
        },
        media: '../../blockly/media/',
        // zoom: { controls: true, wheel: true },
        zoom: { controls: false, wheel: false },
        move: { wheel: true },
        // MARK: 更改主题方式
        theme: Blockly.Theme.GTheme,
        // MARK: 渲染器，用于积木的形状
        renderer: this.rendererName,
        //积木注释
        comments: false,
      })

      if (oldWorkspaceXml) {
        oldWorkspaceXmlTmp = Blockly.Xml.textToDom(oldWorkspaceXmlTxt)
        Blockly.Xml.domToWorkspace(oldWorkspaceXmlTmp, this.workspace)
        this.oldWorkspaceXmlTxt = oldWorkspaceXmlTxt
      }

      // 每一次初始化，需要重新事件绑定
      this.BindResetSvg(resetSvgDom, this.workspace)

      // TODO:图片变量删除后撤销，需要再次创建
      this.workspace.addChangeListener(this.blockChangeListene)
      // this.workspace.addChangeListener(this.changeblock);
      Blockly.Events.BLOCK_MOVE = function() {
        console.log('ok ')
      }
      Blockly.Events.BlockMove()

      // 代码回收箱（垃圾桶）盖子不可点
      this.workspace.trashcan.svgLid_.style.pointerEvents = 'none'
      this.workspace.getMetrics = this.getMetrics

      Blockly.BlockSvg.moveBy = this.blockMoveHandler
    },
    changeblock() {
      console.log('监听')
    },
    blockMoveHandler(block) {
      console.log(block)
    },
    // Blockly flyout 位置处理
    getMetrics() {
      var _ws = this.workspace
      var toolboxDimensions = Blockly.WorkspaceSvg.getDimensionsPx_(
        _ws.toolbox_
      )
      var flyoutDimensions = Blockly.WorkspaceSvg.getDimensionsPx_(_ws.flyout_)

      // Contains height and width in CSS pixels.
      // svgSize is equivalent to the size of the injectionDiv at this point.
      var svgSize = Blockly.svgSize(_ws.getParentSvg())
      var viewSize = { height: svgSize.height, width: svgSize.width }
      // TODO:
      // console.log(_ws.toolbox_)
      if (_ws.toolbox_) {
        if (
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_TOP ||
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_BOTTOM
        ) {
          viewSize.height -= toolboxDimensions.height
        } else if (
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_LEFT ||
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_RIGHT
        ) {
          viewSize.width -= toolboxDimensions.width
        }
      } else if (_ws.flyout_) {
        if (
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_TOP ||
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_BOTTOM
        ) {
          viewSize.height -= flyoutDimensions.height
        } else if (
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_LEFT ||
          _ws.toolboxPosition == Blockly.TOOLBOX_AT_RIGHT
        ) {
          viewSize.width -= flyoutDimensions.width
        }
      }

      // svgSize is now the space taken up by the Blockly workspace, not including
      // the toolbox.
      var contentDimensions = Blockly.WorkspaceSvg.getContentDimensions_(
        _ws,
        viewSize
      )

      var absoluteLeft = 0
      if (_ws.toolbox_ && _ws.toolboxPosition == Blockly.TOOLBOX_AT_LEFT) {
        absoluteLeft = toolboxDimensions.width

        // MARK: 代码回收箱 flyout 位置微调
        // 积木放进去时段点击，会引起 isOpen 不起作用，其原因大致是性能
        if (_ws.trashcan.isOpen) {
          absoluteLeft = toolboxDimensions.width - 70
        }
      } else if (
        _ws.flyout_ &&
        _ws.toolboxPosition == Blockly.TOOLBOX_AT_LEFT
      ) {
        absoluteLeft = flyoutDimensions.width
      }
      var absoluteTop = 0
      if (_ws.toolbox_ && _ws.toolboxPosition == Blockly.TOOLBOX_AT_TOP) {
        absoluteTop = toolboxDimensions.height
      } else if (_ws.flyout_ && _ws.toolboxPosition == Blockly.TOOLBOX_AT_TOP) {
        absoluteTop = flyoutDimensions.height
      }

      var metrics = {
        contentHeight: contentDimensions.height,
        contentWidth: contentDimensions.width,
        contentTop: contentDimensions.top,
        contentLeft: contentDimensions.left,

        viewHeight: viewSize.height,
        viewWidth: viewSize.width,
        viewTop: -_ws.scrollY,
        viewLeft: -_ws.scrollX,

        absoluteTop: absoluteTop,
        absoluteLeft: absoluteLeft,

        svgHeight: svgSize.height,
        svgWidth: svgSize.width,

        toolboxWidth: toolboxDimensions.width,
        toolboxHeight: toolboxDimensions.height,

        flyoutWidth: flyoutDimensions.width,
        flyoutHeight: flyoutDimensions.height,

        toolboxPosition: _ws.toolboxPosition,
      }
      return metrics
    },
    setToolboxText() {
      var MSG = this.MSG

      for (var messageKey in MSG) {
        if (messageKey.indexOf('cat') == 0) {
          Blockly.Msg[messageKey.toUpperCase()] = MSG[messageKey]
        }
      }

      // Construct the toolbox XML, replacing translated variable names.
      var toolboxText = document.getElementById('toolBox').outerHTML
      toolboxText = toolboxText.replace(/(^|[^%]){(\w+)}/g, function(
        m,
        p1,
        p2
      ) {
        return p1 + MSG[p2]
      })

      return Blockly.Xml.textToDom(toolboxText)
    },
    // 数据库类别和积木存储差不多，只是有没有积木内容而已
    // 利用分类名(blockName-数据库名)，和分类Id 进行添加分类
    addCustomBlockCategory(blockName, blockId) {
      var xmlDom = document.createElement('category')
      xmlDom.setAttribute('id', blockId)
      xmlDom.setAttribute('name', blockName)
      // TODO: 后期修改
      // xmlDom.setAttribute("colour", "red");

      // if (parentXmlDom) {
      //   parentXmlDom.appendChild(xmlDom);
      //   resultXmlDom = parentXmlDom;
      // }

      return xmlDom
    },
    // 将积木添加到相应类别里面blockCodeTxt:积木脚本
    addCustomBlockByJS(
      Blockly,
      parentXmlDom,
      blockCodeTxt,
      blockName,
      thisObj
    ) {
      var typename = blockName,
        reg_label = /<label|<button/g, //验证label和button标签文本，并配置
        // reg_button = /<label/g,
        // blockCreateTxt = "return" + codeTxts[1],
        blockCreateTxt = blockCodeTxt
          ? blockCodeTxt.replace(/},/g, '};')
          : null,
        // blockCreate = new Function("Blockly", blockCreateTxt),
        blockCreate,
        blockCreateJSText,
        blockCreatePythonText,
        blockCreateJS,
        blockCreatePython,
        blockXml,
        blockXmlDom = null,
        shadowXml = null, //xml片段
        blockJsIndex,
        blockStyle,
        // parentXmlNode = parentXmlDom,
        O = thisObj ? thisObj : this //运行环境

      // 添加的代码文本遗漏
      if (!blockCodeTxt) {
        return null
      }
      // 文本标签的添加
      if (reg_label.test(blockCodeTxt)) {
        let blockCreateXMl = '<xml>' + blockCodeTxt + '</xml>'
        blockXmlDom = Blockly.Xml.textToDom(blockCreateXMl).firstChild
        return blockXmlDom
      }

      blockJsIndex = blockCreateTxt.indexOf('Blockly.Python')
      // // 积木脚本
      blockCreateJSText = blockCreateTxt.slice(0, blockJsIndex)
      //解析出积木样式
      blockStyle = this.getBlockStyleByText(blockCreateTxt)
      // console.log("blockStyle",blockStyle)
      // 对应python脚本
      blockCreatePythonText = blockCreateTxt.slice(blockJsIndex)

      try {
        blockCreateJS = new Function('Blockly', blockCreateJSText) //新建积木函数
        blockCreateJS.call(O, Blockly)
        blockCreatePython = new Function('Blockly', blockCreatePythonText) //新建积木函数
        blockCreatePython.call(O, Blockly)
      } catch (error) {
        console.error(error)
      } finally {
        if (Blockly.Blocks[typename]) {
          blockXml = O.workspace.newBlock(typename) //新建的积木
          blockXmlDom = Blockly.Xml.blockToDom(blockXml) //工具箱创建积木
          //对积木进行组合处理
          if (/appendValueInput/.test(blockCreateJSText)) {
            shadowXml = document.createDocumentFragment()
            var parser = new DOMParser()
            var xmldom_2 = parser.parseFromString('<root></root>', 'text/xml') //创建xml文档;
            var num = this.getChartNum(blockCreateJSText, 'appendValueInput')
            for (let i = 0; i < num; i++) {
              // 获得xml的shadow节点 name属性的名字
              var index = blockCreateJSText.indexOf('appendValueInput', i)
              var str = blockCreateJSText.substr(index, 50) //初步切割代码;
              var index_2 = str.indexOf('.set')
              str = str.slice(0, index_2).trim()
              var index_3 = str.indexOf('(')
              str = str.slice(index_3 + 2)
              var index_4 = str.indexOf('(')
              str = str.slice(0, index_4 - 1)
              // 将一段xml节点添加给blockXmlDom
              var valueXml = xmldom_2.createElement('value')
              valueXml.setAttribute('name', str)
              valueXml.innerHTML = `<shadow type='${blockStyle}_item'></shadow>` //可以用innerHTML方式;
              shadowXml.appendChild(valueXml)
              blockXmlDom.appendChild(shadowXml) //
            }
          }
        }
      }

      return blockXmlDom //建立<block></block>标签元素
    },
    //解析出积木样式
    getBlockStyleByText(blockTxt) {
      let reg_style = /(?<=this.setStyle\()(.*?)(?="\))/, //截取指定内容
        reg_color = /(?<=this.setColor\().*(?=\))/, //截取指定内容
        quotation_reg = /"|'/g, //截取指定内容
        blockStyleArr = [],
        blockColorArr = [],
        blockStyle,
        index
      if (!blockTxt) {
        return 'gta_ai_event'
      }
      blockStyleArr = blockTxt.match(reg_style)

      if (blockStyleArr && blockStyleArr.length > 0) {
        blockStyle = blockStyleArr[0]
        // if(blockStyle.length>30){
        // }
      } else {
        return 'gta_ai_event'
      }
      // if(blockColorArr&&blockColorArr.length>0){
      //     blockStyle= blockColorArr[0]
      // }else{
      //  return 'gta_ai_event'
      // }
      blockStyle = blockStyle.replace(quotation_reg, '')
      return blockStyle
    },
    // 将从数据获取的类别和积木信息放到工具箱里面
    async addBlockCollectionToToolbox(Blockly, parentXmlDom, blocks) {
      var self = this,
        rootCategorys = [],
        blocksListSorted = [],
        rootXml = document.createDocumentFragment(),
        toolboxXml = document.getElementById('toolBox'),
        oldWorkspaceXml = Blockly.Xml.workspaceToDom(this.workspace)
      let blocksList = JSON.parse(JSON.stringify(blocks)) //数据库返回的所有类型积木
      if (!blocksList.length || blocksList.length < blocks.length) {
        return
      }
      // 获取自建积木类型
      let newBlocksTypeArr = blocksList.filter(
        (block) =>
          block.blocksName === '新建积木' &&
          block.parentId === '00000000-0000-0000-0000-000000000000'
      )

      let newBlocksType = newBlocksTypeArr[0]
      // 添加‘新建积木’的类型的功能积木;
      // blocksList.push(this.newBlocksType);

      //添加'新建积木'弹框的积木
      let newBlocks = this.newBlocks
      newBlocks.map((newBlock) => {
        newBlock.parentId = newBlocksType.blocksId
        return newBlock
      })

      blocksList = blocksList.concat(newBlocks)
      // console.log("blocksListblocksList", blocksList);
      this.$store.state.CREATEBLOCK.newBlocks = newBlocks //存在全局变量中;
      this.$store.state.CREATEBLOCK.newBlocksType = newBlocksType //存在全局变量中;
      this.newBlocksType = newBlocksType
      this.newBlocks = newBlocks

      //排序
      blocksListSorted = blocksList.sort((prevBlock, nextBlock) => {
        // 层级
        if (prevBlock.blocksLevel - nextBlock.blocksLevel != 0) {
          return prevBlock.blocksLevel - nextBlock.blocksLevel
        } else {
          // 同层级里面做排序
          return prevBlock.blocksOrder - nextBlock.blocksOrder
        }
      })

      /*
     @author zlh
    对有工具箱有分类显示的数据进一步处理
    */
      let blocksListSorted_2 = [...blocksListSorted]
      let blocksListSorted_3 = blocksListSorted_2.filter((block) => {
        //打印相关积木
        // if (/gta_trainedmodel_api/.test(block.blocksName)) {
        //   // console.log('筛选植物的积木', block.blocksName)
        // }
        try {
          if (block.blocksLevel == 5) {
            return block
          }
        } catch (e) {
          console.log(e)
        }
      })
      //遍历删除level ==5的元素，然后再按一定规则添加回数组
      blocksListSorted_2 = blocksListSorted_2.filter((block) => {
        try {
          if (block.blocksLevel != 5) {
            return block
          }
        } catch (e) {
          console.log(e)
        }
      })
      let blocksListSorted_4 = [...blocksListSorted_2],
        num = 0

      for (let i = 0, len = blocksListSorted_3.length; i < len; i++) {
        blocksListSorted_2.findIndex((block, index, arr) => {
          if (block.blocksId == blocksListSorted_3[i].parentId) {
            blocksListSorted_3[i].parentId = block.parentId
            blocksListSorted_4.splice(index + num + 1, 0, blocksListSorted_3[i])
            num++
          }
        })
      }
      blocksListSorted_4.forEach(function addBlock(block, index) {
        var blockCodeTxt = block.blocksContent, //定义积木块的方法
          blockType = block.showType,
          blockName = block.blocksName, //积木名称
          xmlDom,
          // toolboxXml = document.getElementById("toolBox"),
          parentXmlDom

        //标签的积木添加到相应类型的工具箱
        // console.log("blockName,blockName", blockName);
        // if (blockName === "大声道阿斯顿发生的") {
        // }
        // 创建积木
        if (blockType === 1) {
          xmlDom = self.addCustomBlockCategory(
            //积木分类
            block.blocksName,
            block.blocksId
          )
        } else {
          xmlDom = self.addCustomBlockByJS(
            //生成自定义积木
            //积木块
            Blockly,
            null,
            blockCodeTxt,
            blockName,
            self
          )
        }
        // 插入父元素
        if (block.parentId === '00000000-0000-0000-0000-000000000000') {
          rootXml.appendChild(xmlDom)
          // 将头一级的 Categorys 进行收集
          rootCategorys.push({
            type: block.blocksName,
            id: block.blocksId,
          })
        } else {
          // 有可能出现 xmlDom 返回 null 的情况
          // 同时还需要有父元素
          if (xmlDom && block.parentId) {
            parentXmlDom = rootXml.querySelector(
              "[id='" + block.parentId + "']"
            )
            if (parentXmlDom) parentXmlDom.appendChild(xmlDom)
          }
        }
      })

      toolboxXml.appendChild(rootXml)

      self.workspace.dispose() //处置，防止内存泄漏prevent memory leaks

      await self.blocklyInit(oldWorkspaceXml)

      //注册创建新积木按钮
      this.workspace.registerButtonCallback(
        'openCreateBlockFun',
        this.openCreateBlockDialog
      )
    },

    //调整工具箱文本标签的样式
    toolboxLabelStyle() {
      let blocklyTreeRowList = document.querySelectorAll('.blocklyTreeRow')
      blocklyTreeRowList.forEach((blocklyTreeRow) => {
        let nextElement = blocklyTreeRow.nextElementSibling
        let nextChildNodes = nextElement.childNodes
        let roleArrtibute = nextElement.getAttribute('role')
        let blocklyTreeIcon = blocklyTreeRow.getElementsByClassName(
          'blocklyTreeIcon'
        )[0]

        if (blocklyTreeIcon) {
          let floatWise = this.getArrtributeStyle(blocklyTreeIcon, 'float')
          if (nextChildNodes.length == 0 && floatWise == 'right') {
            //  给有下一级分类的元素增加一个类名
            // blocklyTreeIcon.style.display = "none";
            blocklyTreeRow.classList.add('has-not-tree')
          }
        }
      })
    },
    //读取样式
    getArrtributeStyle(oElement, sName) {
      return oElement.currentStyle
        ? oElement.currentStyle[sName]
        : getComputedStyle(oElement, null)[sName]
    },
    modeToCode() {
      this.attemptCodeGeneration(Blockly.Python)
    },
    // 将积木转化为代码
    attemptCodeGeneration(generator) {
      if (this.checkAllGeneratorFunctionsDefined(generator)) {
         //将积木转化为python代码
        Blockly.Python.STATEMENT_PREFIX = '';
        generator.addReservedWords('');
        var code = generator.workspaceToCode(this.workspace);
        // 处理代理字段
        if (window.location.protocol === 'https:' && !(code.indexOf('service_photoDomain') !== -1)) {
          let fileBaseUrl = window.gtaAiConfig.fileBaseUrl;
          code = code.replace(/\/service_photoDomain/g, fileBaseUrl);
        }
        this.pythonEditorCode = code;
      }
    },
    // 检查是否所有的积木都有代码实现
    checkAllGeneratorFunctionsDefined(generator) {
      var blocks = this.workspace.getAllBlocks(false)
      var missingBlockGenerators = []

      for (var i = 0; i < blocks.length; i++) {
        var blockType = blocks[i].type
        if (!generator[blockType]) {
          if (missingBlockGenerators.indexOf(blockType) == -1) {
            missingBlockGenerators.push(blockType)
          }
        }
      }

      var valid = missingBlockGenerators.length == 0
      if (!valid) {
        var msg =
          'The generator code for the following blocks not specified for ' +
          generator.name_ +
          ':\n - ' +
          missingBlockGenerators.join('\n - ')
        Blockly.alert(msg) // Assuming synchronous. No callback.
      }
      return valid
    },
    onresize() {
      Blockly.svgResize(this.workspace)
    },
    undoHandle() {
      Blockly.mainWorkspace.undo()
    },
    redoHandle() {
      Blockly.mainWorkspace.undo(1)
    },
    BindResetSvg(resetSvgDom, ws) {
      // Attach event listeners.
      Blockly.bindEventWithChecks_(resetSvgDom, 'click', null, function(e) {
        try {
          ws.markFocused()
          ws.setScale(ws.options.zoomOptions.startScale)
          ws.beginCanvasTransition()
          ws.cleanUp() //一键对齐
          ws.scrollCenter()
          setTimeout(ws.endCanvasTransition.bind(ws), 500)
          Blockly.Touch.clearTouchIdentifier() // Don't block future drags.
          e.stopPropagation() // Don't start a workspace scroll.
          e.preventDefault() // Stop double-clicking from selecting text.
        } catch (error) {
          // console.log(error)
        }
      })
    },
    runHandle() {
      var code,
        reg = /[\n\r]$/,
        generator = Blockly.Python
      if (
        this.checkAllGeneratorFunctionsDefined(generator) &&
        this.workspaceIsVisible
      ) {
        //将积木转化为python代码
        Blockly.Python.STATEMENT_PREFIX = ''
        generator.addReservedWords('')
        code = generator.workspaceToCode(this.workspace)
      } else if (!this.workspaceIsVisible) {
        code = this.pythonEditorCode
        if (!reg.test(code)) {
          code = code + '\n'
        }
      }
      this.pythonEditorCode = code //获取python脚本;
      this.$store.state.blocklyHome.codeText = code
      return code
    },
    clearWorkspace() {
      // Clear the workspace to avoid merge.
      this.workspace.clear()
    },
    // xmlDoc 转化为 workspace
    textToWorkspace(xmlText) {
      // 是否有值
      if (!xmlText) {
        return
      }
      // Blockly.Xml.dispose(); //清除旧积木
      this.workspace.clear() //清除旧的积木数据
      var xmlDom = Blockly.Xml.textToDom(xmlText)
      this.prevSaveWorkSpaceXmlTxt = this.saveFlag
        ? this.prevSaveWorkSpaceXmlTxt
        : xmlText // 记录第一次保存前的状态创建时候的代码状态

      Blockly.Xml.domToWorkspace(xmlDom, this.workspace)

      // 积木居中显示
      setTimeout(() => {
        var resetSvgDom = document.getElementById('btnResetSvg')
        if (resetSvgDom) {
          resetSvgDom.click()
        }
      }, 100)
    },
    workspaceToDom() {
      return Blockly.Xml.workspaceToDom(this.workspace)
    },

    coloursFlyoutCallback(/* workspace */) {
      var self = this
      return self.createBlocksByList(
        self.picTempList,
        self.camTempList,
        self.audioTempList,
        self.textTempList
      )
    },
    // 从 workspace XML 中提取图片/摄像头/音频节点-typestrurl, renameVal 用于给积木重命名
    // createBlocksByWorkspaceXML(oldWorkspaceXmlTxt, typestrurl, renameVal) {
    //   //从工作台创建媒体类积木
    //   // this.createMediaBlocksByWorkspaceXML(
    //   //   oldWorkspaceXmlTxt,
    //   //   typestrurl,
    //   //   renameVal
    //   // )
    // },

    // 积木 Xml 数据更新
    xmlDataUpdate() {
      var token = this.$store.state.token,
        projectId = this.ProjectId,
        fileData = this.xmlData

      fileData.str = this.workspaceToDom(this.workspace).outerHTML
    },
    // dealBolcks(flyoutBlocks) {
    //   flyoutBlocks.forEach((BlocksSvg) => {
    //     let childrenSvgs = BlocksSvg.getChildren()
    //     let path = BlocksSvg.svgPath_
    //     let Filed = BlocksSvg.Filed
    //   })
    // },
    // 积木事件监听
    blockChangeListene(event) {
      // console.log('event', event)
      //获取工具箱弹框的积木，进而判断自定义积木中的哪一个弹框
      var flyoutBlocks = this.workspace
        .getFlyout()
        .getWorkspace()
        .getTopBlocks()
      // this.dealBolcks(flyoutBlocks)
      // var allBlocks = this.workspace.getAllBlocks();

      //工具箱文本标签样式的调整，需要异步才能读取style属性
      this.toolboxLabelStyle()
      // TODO:图片变量删除后撤销，需要再次创建
      var type = '',
        prefix = 'MEDIAPIC',
        prefix2 = 'MEDIACAM',
        prefix3 = 'MEDIAAUDIO',
        hasPicTemp,
        hasCamTemp,
        hasTemp,
        urlstr
      if (event.type === 'create') {
        type = event.xml.getAttribute('type')
        if (type.indexOf(prefix) > -1) {
          urlstr = type.substring(type.indexOf(prefix) + prefix.length)
          let nameIndex = urlstr.indexOf('mediaFileName='),
            mediaFileName = urlstr.substring(nameIndex)
          urlstr = urlstr.substring(0, nameIndex)
          mediaFileName = mediaFileName.replace('mediaFileName=', '')
          urlstr = this.$util.urlToStr.decrypt(urlstr)
          urlstr = decodeURIComponent(urlstr)
          //缓存
          this.picTempList.forEach((picTem) => {
            if (picTem.mediaFileUrl == urlstr) {
              hasPicTemp = true
            }
          })

          if (!hasPicTemp) {
            this.picTempList.push({
              mediaFileUrl: urlstr,
              mediaFileName: mediaFileName,
            })
          }
        } //if end
        if (type.indexOf(prefix2) > -1) {
          //监听摄像头积木
          urlstr = type.substring(type.indexOf(prefix2) + prefix2.length)
          let nameIndex2 = urlstr.indexOf('mediaFileName'),
            MediaFileName2 = urlstr.substring(nameIndex2)
          urlstr = urlstr.substring(0, nameIndex2)
          MediaFileName2 = MediaFileName2.replace('mediaFileName=', '')
          urlstr = this.$util.urlToStr.decrypt(urlstr)
          urlstr = decodeURIComponent(urlstr)
          this.camTempList.forEach((camTem) => {
            if (new RegExp(camTem.mediaFileUrl).test(urlstr)) {
              hasCamTemp = true
            }
          })

          if (!hasCamTemp) {
            // this.camTempList.push({
            //   mediaFileUrl: urlstr,
            //   mediaFileName: MediaFileName2
            // });
            // this.picTempList.push(urlstr);
          }
        } //if end
        if (type.indexOf(prefix3) > -1) {
          //监听音频积木
          urlstr = type.substring(type.indexOf(prefix3) + prefix3.length)
          let nameIndex3 = urlstr.indexOf('mediaFileName'),
            MediaFileName3 = urlstr.substring(nameIndex3)
          urlstr = urlstr.substring(0, nameIndex3)
          MediaFileName3 = MediaFileName3.replace('mediaFileName=', '')
          urlstr = this.$util.urlToStr.decrypt(urlstr)
          urlstr = decodeURIComponent(urlstr)
          this.audioTempList.forEach((audioTemp) => {
            if (audioTemp.mediaFileUrl == urlstr) {
              hasTemp = true
            }
          })

          if (!hasTemp) {
            this.audioTempList.push({
              mediaFileUrl: urlstr,
              mediaFileName: MediaFileName3,
            })
            // this.picTempList.push(urlstr);
          }
        } //if end
      }
    },
    //设置积木渐变类型
    blocksGradient() {
      var defaultBlockStyles = GTheme.defaultBlockStyles
      var blocklySvg = document.getElementsByClassName('blocklySvg')[0]
      for (var i in defaultBlockStyles) {
        var styleName = i //获取对象的键名
        var colour = defaultBlockStyles[i].colourPrimary
        var defs = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'defs'
        )
        var linearGradient = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'linearGradient'
        )
        linearGradient.setAttribute('id', styleName)
        linearGradient.setAttribute('x1', '0%')
        linearGradient.setAttribute('y1', '0%')
        linearGradient.setAttribute('x2', '100%')
        linearGradient.setAttribute('y2', '0%')
        var stop_1 = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'stop'
        )
        var stop_2 = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'stop'
        )
        stop_1.setAttribute('offset', '0%')
        stop_1.setAttribute('stop-opacity', '1')
        stop_1.setAttribute('stop-color', colour)
        stop_2.setAttribute('offset', '100%')
        stop_2.setAttribute('stop-opacity', '1')
        // stop_2.setAttribute("stop-opacity", "0.5");
        stop_2.setAttribute('stop-color', colour)
        linearGradient.appendChild(stop_1)
        linearGradient.appendChild(stop_2)
        defs.appendChild(linearGradient)
        blocklySvg.appendChild(defs)
      }
    },
    // 字符串出现次数
    getChartNum(str, chart) {
      var index = str.indexOf(chart) // 字符出现的位置
      var num = 0 // 这个字符出现的次数
      while (index !== -1) {
        num++ // 每出现一次 次数加一
        index = str.indexOf(chart, index + 1) // 从字符串出现的位置的下一位置开始继续查找
      }
      return num
    },
    // 取消弹窗
    cancelPopup() {
      if (this.popupActive) {
        this.popupActive = ''
      }
    },

    //取消关闭
    cancelLocalCamera() {
      this.popupActive = ''
    },

    //取消网络摄像头关闭
    cancelNetCamera() {
      this.popupActive = ''
      this.netCamera.isPreview = false
      this.netCamera.path = ''
    },

    // 将积木文本添加到左侧工具箱;
    addBlockTextToTool(blockItem) {
      const toolboxXml = document.getElementById('toolBox'),
        oldWorkspaceXml = Blockly.Xml.workspaceToDom(this.workspace)
      let xmlDom,
        parentXmlDom, //积木类型的父节点
        blockName = blockItem.defBlocksName,
        // blockName = blockItem.blocksName,
        blockCodeTxt = blockItem.defBlocksContent,
        { newBlocksType } = this //存储新建积木类型
      xmlDom = this.addCustomBlockByJS(
        //生成自定义积木块
        Blockly,
        null,
        blockCodeTxt,
        blockName,
        this
      )
      if (xmlDom && newBlocksType.blocksId) {
        parentXmlDom = toolboxXml.querySelector(
          "[id='" + newBlocksType.blocksId + "']"
        )
        if (parentXmlDom) parentXmlDom.appendChild(xmlDom)
        this.workspace.dispose() //处置，防止内存泄漏prevent memory leaks
        this.blocklyInit(oldWorkspaceXml)
      }
    },
  }, //methods end
}
</script>
<style lang="scss" scoped>
@import './BaseBlockEditor.scss';
</style>
